import { call, put, select } from 'redux-saga/effects';
import getQuestionsDecisionTree from 'api/decisionTree';
import computableContractsActions from 'redux/actions/decisionTreeActions';
import { partnerSelector } from 'redux/selectors/config';
import applicationSpinnerActions from 'redux/actions/applicationSpinnerActions';
import { push } from 'connected-react-router';
import { routes } from 'Routes/routesConfig';
import decisionTreeActions from '../../actions/decisionTreeActions';

const { getQuestionsDecisionTreeSuccess } = computableContractsActions;
const { startLoad, stopLoad } = applicationSpinnerActions;
const { getQuestionsDecisionTree: getQuestionsDecisionTreeAction } =
  decisionTreeActions;

export function* getQuestionsSaga({
  payload: {
    language,
    lines,
    optionSelected,
    productId,
    question,
    displayName,
    match,
    retryAttempt = 0,
  },
}) {
  try {
    yield put(startLoad());
    const partner_reference = yield select(partnerSelector);
    const { result } = yield call(getQuestionsDecisionTree, {
      language,
      lines,
      optionSelected,
      partner_reference,
      productId,
      match,
    });
    const lastLineState = lines[0].state.length - 1;
    if (result.error) {
      if (retryAttempt < 2) {
        yield put(
          getQuestionsDecisionTreeAction({
            language,
            lines,
            productId,
            question,
            displayName,
            match,
            retryAttempt: retryAttempt + 1,
          }),
        );
      } else {
        yield put(push(routes.DROPOFF));
      }
    } else {
      yield put(
        getQuestionsDecisionTreeSuccess(
          lines[0].state
            .filter(
              stateItem => stateItem.id === lines[0].state[lastLineState]?.id,
            )
            .map(stateItem => stateItem.value)
            .sort()
            .join('|'),
          displayName,
          language,
          optionSelected,
          lines[0].state[lastLineState]?.id,
          result,
          question,
          match,
        ),
      );
    }
  } catch (error) {
    if (retryAttempt < 2) {
      yield put(
        getQuestionsDecisionTreeAction({
          language,
          lines,
          productId,
          question,
          displayName,
          match,
          retryAttempt: retryAttempt + 1,
        }),
      );
    } else {
      yield put(push(routes.DROPOFF));
    }
  } finally {
    yield put(stopLoad());
  }
}
